<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
    export default {
        data () {
          return {

          }
        },
        mounted () {

        },
        beforeDestroy () {

        },
        methods: {
          
        }
    }
</script>
